'use strict';

exports.__esModule = true;
exports.default = undefined;

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Option = require('../Option');

var _Option2 = _interopRequireDefault(_Option);

var _OptionWrapper = require('../OptionWrapper');

var _OptionWrapper2 = _interopRequireDefault(_OptionWrapper);

var _SelectButton = require('../SelectButton');

var _SelectButton2 = _interopRequireDefault(_SelectButton);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uniqueId = require('lodash/uniqueId');

var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _keycodes = require('../../lib/keycodes');

var keycode = _interopRequireWildcard(_keycodes);

var _optionCollection = require('../../lib/optionCollection');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO This class is way too large. Need to break it down into
// smaller subcomponents somehow. :-/
var Select = (_temp = _class = function (_Component) {
  _inherits(Select, _Component);

  function Select() {
    _classCallCheck(this, Select);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.handleClick = function (e) {
      var open = _this.state.open;

      e.preventDefault();
      e.stopPropagation();
      _this.setState({
        open: !open
      });
    };

    _this.handleClickOutside = function (e) {
      if (_this.wrapperDiv && !_this.wrapperDiv.contains(e.target)) {
        var open = _this.state.open;

        if (open) {
          _this.updateExpandedState(false);
        }
      }
    };

    _this.handleKeyDown = function (e) {
      var _this$state = _this.state,
          open = _this$state.open,
          selectedKey = _this$state.selectedKey,
          highlightedKey = _this$state.highlightedKey;

      if (e.keyCode !== keycode.TAB) {
        e.preventDefault();
        e.stopPropagation();
      }

      switch (e.keyCode) {
        case keycode.DOWN:
          {
            if (!open) {
              _this.updateExpandedState(true);
            }
            _this.highlightOption(_this.options.getNextEnabledKey(highlightedKey));
            break;
          }
        case keycode.UP:
          {
            _this.highlightOption(_this.options.getPreviousEnabledKey(highlightedKey));
            break;
          }
        case keycode.ESC:
          {
            if (open) {
              _this.updateExpandedState(false);
            }
            break;
          }
        case keycode.SPACE:
        case keycode.ENTER:
          {
            if (open) {
              _this.handleOptionSelect(e, highlightedKey);
            } else {
              _this.updateExpandedState(true);
              _this.setState({
                highlightedKey: selectedKey
              });
            }
            break;
          }
        case keycode.TAB:
          {
            if (open) {
              _this.updateExpandedState(false);
            }
            break;
          }
        default:
      }
      return false;
    };

    _this.state = {
      open: false,
      selectedKey: null,
      highlightedKey: null
    };
    _this.options = [];
    return _this;
  }

  Select.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        children = _props.children,
        initialValue = _props.initialValue;

    var optionComponents = _react2.default.Children.toArray(children).filter(function (child) {
      return child.type === _Option2.default;
    });
    this.options = new _optionCollection.OptionCollection(optionComponents);

    if (initialValue) {
      var initialOption = this.options.findOptionByValue(initialValue);
      if (initialOption) {
        this.setState({
          selectedKey: initialOption.key
        });
      }
    }
  };

  Select.prototype.componentDidMount = function componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  };

  Select.prototype.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  };

  Select.prototype.handleOptionHover = function handleOptionHover(e, hoverOverKey) {
    this.highlightOption(hoverOverKey);
  };

  Select.prototype.handleOptionSelect = function handleOptionSelect(_e, clickedKey) {
    this.selectOption(clickedKey);
  };

  Select.prototype.handleOptionWrapperRef = function handleOptionWrapperRef(el) {
    if (el) {
      if (el.getAttribute('tabindex') === '0') {
        el.focus();
      }
    }
  };

  Select.prototype.highlightOption = function highlightOption(highlightedKey) {
    var candidate = this.options.findOptionByKey(highlightedKey);
    if (candidate.props.disabled) {
      return;
    }
    this.setState({
      highlightedKey: highlightedKey
    });
  };

  Select.prototype.selectOption = function selectOption(key) {
    var onChange = this.props.onChange;

    this.updateExpandedState(false);
    this.setState({
      selectedKey: key,
      highlightedKey: null
    });

    var selectedOption = this.options.findOptionByKey(key);
    var selectedValue = selectedOption.props.value;
    if (onChange) {
      onChange(selectedValue);
    }
  };

  Select.prototype.updateExpandedState = function updateExpandedState(open) {
    this.setState({
      open: open
    });
    if (!open) {
      var buttonId = this.props.buttonId;

      var button = document.getElementById(buttonId);
      if (button) {
        button.focus();
      }
    }
  };

  Select.prototype.renderChildren = function renderChildren() {
    var _this2 = this;

    var _state = this.state,
        highlightedKey = _state.highlightedKey,
        selectedKey = _state.selectedKey;

    return this.options.allOptions().map(function (option) {
      return _react2.default.createElement(
        _OptionWrapper2.default,
        {
          key: 'optionwrapper-' + option.key,
          optionKey: option.key,
          selectedKey: selectedKey,
          highlightedKey: highlightedKey,
          label: option.props.label,
          value: option.props.value,
          disabled: option.props.disabled,
          onOptionWrapperRef: _this2.handleOptionWrapperRef,
          onMouseOver: function onMouseOver(e) {
            return _this2.handleOptionHover(e, option.key);
          },
          onClick: function onClick(e) {
            return _this2.handleOptionSelect(e, option.key);
          },
          onKeyDown: function onKeyDown(e) {
            return _this2.handleKeyDown(e);
          }
        },
        option
      );
    });
  };

  Select.prototype.render = function render() {
    var _this3 = this;

    var _state2 = this.state,
        open = _state2.open,
        highlightedKey = _state2.highlightedKey,
        selectedKey = _state2.selectedKey;
    var _props2 = this.props,
        listId = _props2.listId,
        buttonId = _props2.buttonId,
        placeholderText = _props2.placeholderText;

    var highlightedId = highlightedKey ? 'react-a11y-option-' + highlightedKey : undefined;

    return _react2.default.createElement(
      'div',
      {
        className: 'ReactA11ySelect',
        ref: function ref(wrapperDiv) {
          _this3.wrapperDiv = wrapperDiv;
        }
      },
      _react2.default.createElement(
        _SelectButton2.default,
        {
          buttonId: buttonId,
          listId: listId,
          highlightedId: highlightedId,
          open: open,
          onKeyDown: this.handleKeyDown,
          onClick: this.handleClick
        },
        !selectedKey && placeholderText,
        !!selectedKey && this.options.findOptionByKey(selectedKey).props.children
      ),
      _react2.default.createElement(
        'ul',
        {
          id: listId,
          role: 'menu',
          className: 'ReactA11ySelect__ul',
          'aria-hidden': open ? undefined : true,
          'aria-activedescendant': highlightedId
        },
        this.renderChildren()
      )
    );
  };

  return Select;
}(_react.Component), _class.defaultProps = {
  placeholderText: 'Please choose...',
  buttonId: (0, _uniqueId2.default)('react-a11y-button-'),
  listId: (0, _uniqueId2.default)('react-a11y-list-'),
  onChange: function onChange(_value) {}
}, _temp);
exports.default = Select;
Select.propTypes = process.env.NODE_ENV !== "production" ? {
  label: function label(props, propName, componentName) {
    if (!props.label && !props.labelledBy) {
      var msg = 'One of props \'label\' or \'labelledBy\' was not specified in ' + componentName;
      return new Error(msg);
    }
    return null;
  },
  labelledBy: function labelledBy(props, propName, componentName) {
    var msg = 'One of props \'label\' or \'labelledBy\' was not specified in ' + componentName;
    if (!props.label && !props.labelledBy) {
      return new Error(msg);
    }
    return null;
  },
  placeholderText: _propTypes2.default.string,
  initialValue: _propTypes2.default.string,
  buttonId: _propTypes2.default.string,
  listId: _propTypes2.default.string,
  onChange: _propTypes2.default.func
} : {};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-a11y-select/lib/components/Select/index.js
// module id = 1680
// module chunks = 14